import React from 'react';

export default () => {
  return (
    <div className="container">
      <h1>Thanks for the contact, we'll contact you back soon!</h1>
    </div>
  );
}


// WEBPACK FOOTER //
// ./thanks.js